import React, { memo } from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";

/**
 * Header component with React.memo for performance
 * Following React performance best practices
 */
const navLinks = [
    { to: "/", label: "Home" },
    { to: "/beams", label: "Beams" },
];

const Header = memo(function Header(): React.ReactElement {
    const location = useLocation();

    return (
        <>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-blue-600 focus:text-white"
            >
                Skip to content
            </a>
            <header className="border-b border-slate-700 bg-slate-900">
                <nav className="max-w-7xl mx-auto px-4 py-3" aria-label="Main navigation">
                    <div className="flex items-center justify-between">
                        <Link
                            to="/"
                            className="text-lg font-bold text-cyan-400 hover:text-cyan-300 transition-colors"
                        >
                            NEO-SGS1
                        </Link>
                        <div className="flex items-center gap-5">
                            {navLinks.map((link) => {
                                const isActive = location.pathname === link.to;
                                return (
                                    <Link
                                        key={link.to}
                                        to={link.to}
                                        className={`text-sm transition-colors ${
                                            isActive
                                                ? "text-cyan-400 font-medium"
                                                : "text-slate-400 hover:text-slate-200"
                                        }`}
                                        {...(isActive ? { "aria-current": "page" as const } : {})}
                                    >
                                        {link.label}
                                    </Link>
                                );
                            })}
                            <ThemeToggle />
                        </div>
                    </div>
                </nav>
            </header>
        </>
    );
});

export default Header;
